import { useRouter } from 'next/router';

interface TabQueryStateParams {
  sectionIds: string[];
  stickyTop?: number;
}

const scrollTabNavigationIntoPinnedPosition = (stickyTop: number) => {
  const nav = document.getElementById('tabNavigation');
  // Once the nav is already stuck, its own rect always reports stickyTop —
  // read the previous (non-sticky) sibling's natural document position instead,
  // so this keeps working even when the user has already scrolled into a section.
  const anchor = nav?.previousElementSibling ?? nav;
  if (!anchor) return;
  const targetTop = anchor.getBoundingClientRect().bottom + window.scrollY - stickyTop;
  window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
};

export function useTabQueryState({ sectionIds, stickyTop = 0 }: TabQueryStateParams) {
  const router = useRouter();
  const queryParam = router.query.section;
  const requestedSlug = Array.isArray(queryParam) ? queryParam[0] : queryParam;
  const activeTab = requestedSlug && sectionIds.includes(requestedSlug) ? requestedSlug : (sectionIds[0] ?? null);

  const onTabClick = (sectionId: string) => {
    router
      .push({ pathname: router.pathname, query: { ...router.query, section: sectionId } }, undefined, {
        shallow: true,
      })
      .then(() => scrollTabNavigationIntoPinnedPosition(stickyTop))
      .catch((error: unknown) => {
        console.error('Failed to navigate to tab:', error);
      });
  };

  return { activeTab, onTabClick };
}
